import { Badge } from '@/components/ui/badge';
import {
  refillSourceLabel,
  refillStatusLabel,
  type RefillCompletionSource,
  type RefillSessionStatus,
} from '@/lib/refillSession';

const STATUS_CLASS: Record<RefillSessionStatus, string> = {
  PICKING: 'bg-muted text-foreground',
  IN_TRANSIT: 'bg-blue-100 text-blue-800',
  IN_PROGRESS: 'bg-blue-100 text-blue-800',
  COMPLETED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-red-100 text-red-800',
};

export function RefillStatusBadge({ status }: { status: RefillSessionStatus }) {
  return (
    <Badge variant="secondary" className={STATUS_CLASS[status]}>
      {refillStatusLabel(status)}
    </Badge>
  );
}

export function RefillSourceBadge({ source }: { source: RefillCompletionSource | null }) {
  if (!source) {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <Badge variant={source === 'express' ? 'default' : 'outline'}>
      {refillSourceLabel(source)}
    </Badge>
  );
}
